'use client';
import { tokensRaw } from '../../../core/tokens/tokens-raw.js';
import { createResponsiveSystem } from './react-responsive-system/index.js';

let n = {
    xs: parseInt(tokensRaw.SwanBaseBreakpointXsEnd, 10),
    sm: parseInt(tokensRaw.SwanBaseBreakpointSmEnd, 10),
    md: parseInt(tokensRaw.SwanBaseBreakpointMdEnd, 10),
    lg: parseInt(tokensRaw.SwanBaseBreakpointLgEnd, 10),
    xl: 1 / 0
};
const { ScreenClassProvider, ScreenClassContext, useScreenClass, useIsScreenClassInitialized, responsive, useResponsiveProps } = createResponsiveSystem({
    breakpoints: n,
    defaultScreenClass: 'xs',
    cascadeMode: 'mobile-first'
});

export { ScreenClassContext, ScreenClassProvider, responsive, useIsScreenClassInitialized, useResponsiveProps, useScreenClass };
